export function TireconnectLocationCtrl ($scope, $uibModalInstance, $translate, workshopAPI, messages, locations) {
  $scope.locations = locations;
  $scope.id        = '';

  $scope.confirm = function (form) {
    workshopAPI.patch('/company_integrations', {
      tireconnect_location_id : $scope.id
    }, 'company_integration')
    .then(integrations => {
      $uibModalInstance.close();
    })
    .catch(err => {
      messages.error(err);
    });
  };
}